import _ from 'lodash';
import api from '../../api';
import infoBoard from '../../core/infoboard';
import templates from '../../core/templates';
import translate from '../../core/tools/translate';
import environment from '../../environment';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import KendoChart from '../../core/charts/KendoChart';
import moment from 'moment';
import KendoGrid from '../../core/charts/KendoGrid';
import { customScrollbar } from '../../shared';
import databoard from '../../core/databoard';
import { PeriodSelectType } from '../../../enuns/AfterSales/summarySearchType.enum';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);
const LayerControls = name => require('../../controls').get(name);
const LayerInfo = name => require('../../info').get(name);

const _getContainer = (visible = false) =>
    infoBoard.createContainer({
        id: 'summary',
        name: translate('Common.Summary'),
        visible
    });

const _getTemplate = (type, values) => templates(`summary-${type}`, values);

const _addMessage = container => {
    $(container)
        .find('.ballon-container')
        .remove();
    $(container).prepend(
        _getTemplate('message', {
            host: environment.get('IMAGES_HOST')
        })
    );
};

class SummaryAfterSalesInfo {
    static getInstance() {
        if (!SummaryAfterSalesInfo._instance) {
            SummaryAfterSalesInfo._instance = new SummaryAfterSalesInfo();
        }

        return SummaryAfterSalesInfo._instance;
    }

    static _getFilename(text, date, title) {
        return `Neocom_Sumario ${date.name} - ${title} - ${date.yearInitial} a ${date.yearEnd} - v${moment().format('YYYYMMDD')}`;
    }

    buttonBrandEvoluation = null;
    buttonSegmentExtend = null;
    vehicleTypeInput = null;
    segmentInput = null;

    init() { }

    create(options = null) {
        const container = _getContainer(options ? options.visible : false);

        if (!isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.show)) {
            infoBoard.dataUnavailable({
                container,
                message: translate('Error.NoDataAvailable'),
                image: 'no_data'
            });
            return;
        }

        if (!options || !options.id) {
            _addMessage(container);
            if (options.container) {
                _addMessage(options.container);
            }
            return;
        }

        infoBoard.open();

        const actions = infoBoard.createActions(
            {
                export: {
                    value: isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.export),
                    label: translate('Action.ExportSummary')
                }
            },
            'Summary'
        );
        actions.layout.appendTo(container);

        options.actions = actions;
        options.title = options.title || options.name;

        this._loadContainer(options, container);
        this._export(options);

        customScrollbar(container.find('.panel-group'));
    }

    _export(options) {
        options.actions.export.on('click', () => {
            const locales = _.isArray(options.id) ? options.id : [options.id];
            api.afterSales.get.summary.exportExcel(locales, options.name, options.yearInitial, options.yearEnd);
        });
    }

    _loadContainer(options, container) {
        const $layout = $(templates(`summary-view-after-sales`, {
            title: options.title,
            showRanking: isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showRanking),
            showRankingBrand: isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showRankingBrand),
            showVehicleFleetBrand: isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showVehicleFleetBrand)
        }));
        $layout.appendTo(container);

        this._buildPeriodSelect(container, options);
        this._loadData(container, options);
    }

    _loadData(container, options) {
        this._buildVehicleRepairableYear(container, options);

        if (isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showVehicleFleetBrand)) {
            this._buildVehicleRepairableBrand(container, options);
        }

        this._buildVehicleRepairableSegment(container, options);

        if (isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showRanking)) {
            this._buildStoreRanking(container, options);
        }

        if (isAuthorized(FeaturePermission.AFTER_SALES_SUMMARY_INFO.showRankingBrand)) {
            this._buildBrandRanking(container, options);
        }
    }

    _buildStoreRanking(container, options) {
        const buildStoreRankingTable = (dataSource, columns) => {
            const title = `${translate('Common.AfterSalesNetwork')} (Top 10)`;
            const filename = SummaryAfterSalesInfo._getFilename("Redes Top 10", options, 'Redes Top 10');
            const chart = {
                container: container.find('#summary-stores-ranking'),
                data: dataSource,
                options: {
                    title,
                    filename,
                    width: 318,
                    // Acompanha .summary-charts-ranking, que reserva a caixa para as linhas
                    // mais a linha de total. O KendoGrid soma 20 no .chart-content.
                    height: 300,
                    convertTable: false,
                    columns: columns,
                    filterable: false,
                    autoheight: false,
                    scrollable: true,
                    buttons: {
                        export: true
                    }
                }
            };
            new KendoGrid(chart.container, chart.data, chart.options);
        };

        const locales = _.isArray(options.id) ? options.id : [options.id];
        api.afterSales.get.summary.storesRanking(locales)
            .then(data => {
                buildStoreRankingTable(data.storeRanking.table.data, data.storeRanking.table.columns);
            });
    }

    _buildBrandRanking(container, options) {
        const buildBrandRankingTable = (dataSource, columns) => {
            const title = 'Marcas (Top 10)';
            const filename = SummaryAfterSalesInfo._getFilename("Marcas Top 10", options, 'Marcas Top 10');
            const chart = {
                container: container.find('#summary-brands-ranking'),
                data: dataSource,
                options: {
                    title,
                    filename,
                    width: 318,
                    // Mesma caixa e mesmo motivo do ranking de redes acima.
                    height: 300,
                    convertTable: false,
                    columns: columns,
                    filterable: false,
                    autoheight: false,
                    scrollable: true,
                    buttons: {
                        export: true
                    }
                }
            };
            new KendoGrid(chart.container, chart.data, chart.options);
        };

        const locales = _.isArray(options.id) ? options.id : [options.id];
        api.afterSales.get.summary.brandsRanking(locales)
            .then(data => {
                buildBrandRankingTable(data.brandRanking.table.data, data.brandRanking.table.columns);
            });
    }

    _buildVehicleRepairableSegment(container, options) {
        const self = this;

        if (this.buttonSegmentExtend) {
            this.buttonSegmentExtend.destroy();
        }

        this.buttonSegmentExtend = $('#summary-vehicle-repairable-segment-extend-button')
            .kendoButton({
                click() {
                    self._buildVehicleRepairableSegmentExtend(options);
                }
            })
            .data('kendoButton');

        this._loadSegmentInputs(container, (segments) => {
            this._buildVehicleRepairableSegmentChart(container, options, segments);
        });
    }

    _buildVehicleRepairableSegmentExtend(options) {
        const locales = _.isArray(options.id) ? options.id : [options.id];
        api.afterSales.get.summary.vehicleRepairableSegmentExtend(locales, options.yearInitial, options.yearEnd)
            .then(data => {
                data.title = translate('Summary.RepairableFleetBySegment');
                data.nameFile = `${environment.get('CONFIG.CLIENT')}_Frota Reparavel - Segmentos Estendida_${options.name}_v${moment().format('YYYYMMDD')}`;
                data.convertTable = false;
                data.scrollable = true;
                data.sortable = true;
                data.size = '50%';
                data.buttons = {
                    fullscreen: true,
                    export: true
                };

                databoard.show(data);
            });
    }

    _buildVehicleRepairableSegmentChart(container, options, segments) {
        const locales = _.isArray(options.id) ? options.id : [options.id];
        const filename = SummaryAfterSalesInfo._getFilename("Frota Reparável por Segmento", options, translate('Summary.RepairableFleetBySegment'));

        api.afterSales.get.summary.vehicleRepairableSegment(locales, options.yearInitial, options.yearEnd, segments)
            .then(data => {
                const options = {
                    container: container.find('#summary-vehicle-repairable-segment-chart'),
                    data: {
                        data: data,
                        type: 'bar',
                        label: true,
                        simple: true,
                        format: '{0:n0}',
                        gap: 0.25,
                        spacing: 0
                    },
                    options: {
                        filename: filename,
                        convertTable: true,
                        height: data.getTotalColumns() * 30,
                        margin: {
                            right: 40
                        },
                        buttons: {
                            export: true
                        }
                    }
                };

                new KendoChart(options.container, options.data, options.options);

                options.container.find('.chart-header').hide();

                container.find('#summary-vehicle-repairable-segment-header .charts-buttons').off('click').on('click', () => {
                    options.container.find('.chart-header .charts-buttons > a').trigger('click');
                });
            });
    }

    _loadSegmentInputs(container, onChange) {
        const sourceSegments = environment.get('CONFIG.FILTERS.SEGMENTS_CLIENT');
        const vehicleTypes = _(sourceSegments).map(x => ({
            id: x.vehicleTypeId,
            name: x.vehicleTypeName
        }))
            .orderBy('name')
            .uniqBy('id')
            .value();

        const filterSegments = (vehicleTypeId) => {
            return vehicleTypeId === ''
                ? sourceSegments
                : _(sourceSegments)
                    .filter(x => x.vehicleTypeId === parseInt(vehicleTypeId, 10))
                    .map(x => ({
                        id: x.segmentId,
                        name: x.segmentName
                    }))
                    .uniqBy('id')
                    .orderBy('name')
                    .value();
        };

        const segments = filterSegments(vehicleTypes[0].id);

        const vehicleTypesData = new kendo.data.DataSource({ data: vehicleTypes });
        const segmentsData = new kendo.data.DataSource({ data: segments });

        container.append(`<script id="vehicleValueTemplate" type="text/x-kendo-template">
            Veículos #:data.name#
        </script>`);

        this.vehicleTypeInput = container.find('#vehicle-repairable-vehicle-type-input')
            .kendoDropDownList({
                valueTemplate: $('#vehicleValueTemplate').html(),
                autoBind: false,
                filter: 'contains',
                dataTextField: "name",
                dataValueField: "id",
                dataSource: vehicleTypesData,
                change: e => {
                    const segments = filterSegments(e.sender.value());
                    segmentsData.data(segments);
                    onChange && onChange(segments.map(x => x.id));
                }
            })
            .data('kendoDropDownList');

        this.vehicleTypeInput.value(vehicleTypes[0].id);

        // this.segmentInput = container.find('#vehicle-repairable-vehicle-segment-input')
        //     .kendoDropDownList({
        //         autoBind: false,
        //         filter: 'contains',
        //         optionLabel: translate('Common.Segment'),
        //         dataTextField: "name",
        //         dataValueField: "id",
        //         dataSource: segmentsData,
        //         change: e => {
        //             const value = e.sender.value() === ''
        //                 ? filterSegments(this.vehicleTypeInput.value()).map(x => x.id)
        //                 : [parseInt(e.sender.value(), 10)];
        //             onChange && onChange(value);
        //         }
        //     })
        //     .data('kendoDropDownList');

        onChange && onChange(segments.map(x => x.id));
    }

    _buildVehicleRepairableBrand(container, options) {
        const locales = _.isArray(options.id) ? options.id : [options.id];
        const buildVehicleRepairableBrandTable = (dataSource, columns) => {
            const title = translate('Summary.RepairableFleetByBrand');
            const filename = SummaryAfterSalesInfo._getFilename("Frota Reparável por Bandeira", options, 'Frota Reparável por Bandeira');
            const chart = {
                container: container.find('#summary-vehicle-repairable-brand-table'),
                data: dataSource,
                options: {
                    title,
                    filename,
                    width: 318,
                    height: 240,
                    convertTable: false,
                    columns: columns,
                    filterable: false,
                    autoheight: false,
                    scrollable: true,
                    buttons: {
                        export: true
                    }
                }
            };
            new KendoGrid(chart.container, chart.data, chart.options);
        };

        api.afterSales.get.summary.vehicleRepairableBrand(locales, options.yearInitial, options.yearEnd)
            .then(data => {
                buildVehicleRepairableBrandTable(data.vehicleRepairableBrand.table.data, data.vehicleRepairableBrand.table.columns);
            });

        const self = this;

        if (this.buttonBrandEvoluation) {
            this.buttonBrandEvoluation.destroy();
        }

        this.buttonBrandEvoluation = $('#summary-vehicle-repairable-brand-evoluation-button')
            .kendoButton({
                click() {
                    self._buildVehicleRepairableBrandEvoluation(options);
                }
            })
            .data('kendoButton');
    }

    _buildVehicleRepairableBrandEvoluation(options) {
        const locales = _.isArray(options.id) ? options.id : [options.id];
        api.afterSales.get.summary.vehicleRepairableBrandEvoluation(locales, options.yearInitial, options.yearEnd)
            .then(data => {
                data.title = 'Evolução de Frota Reparável por Bandeira';
                data.nameFile = `${environment.get('CONFIG.CLIENT')}_Frota Reparavel - Evolução de Mercado_${options.name}_v${moment().format('YYYYMMDD')}`;
                data.convertTable = false;
                data.scrollable = true;
                data.sortable = true;
                data.size = '50%';
                data.buttons = {
                    fullscreen: true,
                    export: true
                };

                databoard.show(data);
            });
    }

    _buildVehicleRepairableYear(container, options) {
        const locales = _.isArray(options.id) ? options.id : [options.id];
        const buildVehicleRepairableChart = (data) => {
            const baseWidth = 60;
            const chartWidth = data._tables[0].columns.length > 5 ? data._tables[0].columns.length * baseWidth : 318;
            const filename = SummaryAfterSalesInfo._getFilename("Frota Reparável", options, 'Frota Reparável');
            const title = translate('Summary.VehicleRepairableFleet');
            const chart = {
                container: container.find('#summary-vehicle-repairable-chart'),
                data: {
                    data,
                    type: ['column'],
                    gap: 0.25,
                    format: '{0:n0}'
                },
                options: {
                    title,
                    filename,
                    width: chartWidth,
                    height: 220,
                    convertTable: true,
                    autocoloring: false,
                    scrollable: true,
                    buttons: {
                        export: true
                    }
                }
            };
            new KendoChart(chart.container, chart.data, chart.options);
        };

        const buildVehicleRepairableTable = (dataSource, columns) => {
            const title = translate('Summary.Detailing');
            const filename = SummaryAfterSalesInfo._getFilename(translate('Summary.Detailing'), options, translate('Summary.Detailing'));
            const chart = {
                container: container.find('#summary-vehicle-repairable-table'),
                data: dataSource,
                options: {
                    title,
                    filename,
                    width: 318,
                    convertTable: false,
                    columns: columns,
                    filterable: false,
                    autoheight: true,
                    scrollable: true,
                    buttons: {
                        export: true
                    }
                }
            };
            new KendoGrid(chart.container, chart.data, chart.options);
        };

        api.afterSales.get.summary.vehicleRepairableYear(locales, options.yearInitial, options.yearEnd, options.typeSearch)
            .then(data => {
                buildVehicleRepairableChart(data.vehicleRepairableYear.chart);
                buildVehicleRepairableTable(data.vehicleRepairableYear.table.data, data.vehicleRepairableYear.table.columns);
            });
    }

    _buildPeriodSelect(container, options) {
        $('.panel-group.has-summary-header').css('top', '160px');
        $('.summary-period').css('height', '92px');

        container.append(`<script id="valueTemplate" type="text/x-kendo-template">
        <div class="select-period-header"><span>#:data.text#</span> <span class="k-icon k-i-calendar"></span></div></script>`);

        container.append(`<script id="valueTypeTemplate" type="text/x-kendo-template">
        <div class="select-period-header"><span>#:data.text#</span> <span class="k-icon k-i-calendar"></span></div></script>`);

        const periods = _(environment.get('CONFIG.FILTERS.FILTERBY')
            .filter(x => x.type === 'Areas-RepairableFleetArea')
            .flatMap(x => x.options)
            .map(x => ({ text: x.nome.replace('-', ' a '), value: x.nome })))
            .value();

        const typeOptions = [
            { text: translate('Common.Annual'), value: PeriodSelectType.ANNUAL },
            { text: translate('Common.Period'), value: PeriodSelectType.PERIOD },
        ];

        let selectedType = PeriodSelectType.PERIOD;

        const dataTypeSource = new kendo.data.DataSource({ data: typeOptions });
        const typePeriodDropDown = container
            .find('.select-type-period')
            .kendoDropDownList({
                valueTemplate: $('#valueTypeTemplate').html(),
                dataTextField: 'text',
                dataValueField: 'value',
                dataSource: dataTypeSource,
                change: e => {
                    selectedType = parseInt(e.sender.value(), 10);

                    let newData = [];

                    if (selectedType === PeriodSelectType.PERIOD) {
                        newData = _(environment.get('CONFIG.FILTERS.FILTERBY')
                            .filter(x => x.type === 'Areas-RepairableFleetArea')
                            .flatMap(x => x.options)
                            .map(x => ({ text: x.nome.replace('-', ' a '), value: x.nome })))
                            .value();
                    }

                    if (selectedType === PeriodSelectType.ANNUAL) {
                        const raw = environment.get('CONFIG.FILTERS.FILTERBY')
                            .find(x => x.type === 'Areas-RepairableFleetArea');

                        const years = raw ? raw.options.flatMap(x => x.nome.split('-')) : [];

                        const allYears = _(years)
                            .map(year => parseInt(year, 10))
                            .filter(Number.isInteger)
                            .sortBy()
                            .value();

                        const minYear = _.first(allYears);
                        const maxYear = _.last(allYears);

                        newData = _.range(minYear, maxYear + 1).map(year => ({
                            text: String(year),
                            value: `${year}-${maxYear}`
                        }));
                    }

                    periodDropDown.setDataSource(newData);

                    const last = _.last(newData).value;
                    if (!last) return;

                    periodDropDown.value(last);

                    if (last.includes('-')) {
                        const [start, end] = last.split('-');
                        options.yearInitial = start;
                        options.yearEnd = end;
                        options.typeSearch = selectedType;
                    }

                    this._loadData(container, options);
                    databoard.hide();
                }
            })
            .data('kendoDropDownList');

        const lastTypePeriodValue = _.last(typeOptions).value;
        typePeriodDropDown.value(lastTypePeriodValue);

        const dataSource = new kendo.data.DataSource({ data: periods });
        const periodDropDown = container
            .find('.select-period')
            .kendoDropDownList({
                valueTemplate: $('#valueTemplate').html(),
                dataTextField: 'text',
                dataValueField: 'value',
                dataSource: dataSource,
                change: e => {
                    const value = e.sender.value();
                    const period = value.split('-');

                    options.yearInitial = period[0];
                    options.yearEnd = period[1];
                    options.typeSearch = selectedType;
                    this._loadData(container, options);

                    databoard.hide();
                }
            })
            .data('kendoDropDownList');

        const lastPeriodValue = _.last(periods).value;
        const periodOfYear = lastPeriodValue.split('-');

        options.yearInitial = periodOfYear[0];
        options.yearEnd = periodOfYear[1];
        options.typeSearch = selectedType;

        periodDropDown.value(lastPeriodValue);
    }

}

export default SummaryAfterSalesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/SummaryAfterSalesInfo.js